import { get, put } from '../utils/httpInterceptor';

class ProfileService {
  static async getCurrentProfile() {
    return await get('/profile');
  }

  static async updateCurrentProfile(payload) {
    return await put('/profile', payload);
  }
}

export default ProfileService;
